// Markets actions
export const EXPAND_COLLAPSE_FIRST_DOWN_MARKET = 'EXPAND_COLLAPSE_FIRST_DOWN_MARKET';
export const EXPAND_ALL_FIRST_DOWN_MARKETS = 'EXPAND_ALL_FIRST_DOWN_MARKETS';
export const COLLAPSE_ALL_FIRST_DOWN_MARKETS = 'COLLAPSE_ALL_FIRST_DOWN_MARKETS';



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/firstDown/constants/actionTypes.js